// class DetailsDisclosure extends HTMLElement {
//   constructor() {
//     super();
//     this.mainDetailsToggle = this.querySelector('details');
//     this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
//   }
//   onFocusOut() {
//     setTimeout(() => {
//       if (!this.contains(document.activeElement)) this.close();
//     })
//   }
//   close() {
//     this.mainDetailsToggle.removeAttribute('open');
//     this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
//   }
// }
// customElements.define('details-disclosure', DetailsDisclosure);

class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.summary = this.mainDetailsToggle.querySelector('summary');
    this.isHeaderMenu = this.closest('.header__inline-menu');

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.summary?.addEventListener('click', (event) => {
      if (!this.isHeaderMenu) return;

      clearTimeout(this.closeTimer);
      this.mainDetailsToggle.classList.remove('is-closing');

      if (this.mainDetailsToggle.open) {
        event.preventDefault();
        this.close();
      }
    });
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  close() {
    this.summary?.setAttribute('aria-expanded', false);

    if (!this.isHeaderMenu) {
      this.mainDetailsToggle.removeAttribute('open');
      return;
    }

    this.mainDetailsToggle.classList.add('is-closing');
    clearTimeout(this.closeTimer);
    this.closeTimer = setTimeout(() => {
      this.mainDetailsToggle.removeAttribute('open');
      this.mainDetailsToggle.classList.remove('is-closing');
    }, 500);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);